import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["title"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (!_ctx.item.meta || !_ctx.item.meta.hidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      (_ctx.isCollapse && _ctx.isFirstLevel) ? 'collapse-mode' : 'expand-mode',
      { 'first-level': _ctx.isFirstLevel },
      `menu-level-${_ctx.menuLevel}`
    ])
      }, [
        (!_ctx.alwaysShowRootMenu && _ctx.theOnlyOneChild && (!_ctx.theOnlyOneChild.children || !_ctx.theOnlyOneChild.children.length))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: _ctx.resolvePath(_ctx.theOnlyOneChild.path),
              class: _normalizeClass({ 'submenu-title-noDropdown': _ctx.isFirstLevel }),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMenuClick(_ctx.resolvePath(_ctx.theOnlyOneChild.path))))
            }, {
              default: _withCtx(() => [
                (_ctx.theOnlyOneChild.meta.icon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["iconfont", _ctx.theOnlyOneChild.meta.icon]),
                      title: (_ctx.isCollapse && _ctx.isFirstLevel) ? _ctx.theOnlyOneChild.meta.title : ''
                    }, null, 10, _hoisted_1))
                  : _createCommentVNode("", true),
                (_ctx.theOnlyOneChild.meta.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.theOnlyOneChild.meta.title), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["index", "class"]))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              index: _ctx.resolvePath(_ctx.item.path)
            }, {
              title: _withCtx(() => [
                (_ctx.item.meta && _ctx.item.meta.icon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["iconfont", _ctx.item.meta.icon]),
                      title: (_ctx.isCollapse && _ctx.isFirstLevel) ? _ctx.item.meta.title : ''
                    }, null, 10, _hoisted_3))
                  : _createCommentVNode("", true),
                (_ctx.item.meta && _ctx.item.meta.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.item.meta.title), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_ctx.item.children && _ctx.item.children.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_sidebar_item, {
                        key: child.meta.menuId,
                        item: child,
                        "is-collapse": false,
                        "is-first-level": false,
                        "menu-level": _ctx.menuLevel + 1,
                        "base-path": _ctx.resolvePath(child.path),
                        class: "nest-menu"
                      }, null, 8, ["item", "menu-level", "base-path"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["index"]))
      ], 2))
    : _createCommentVNode("", true)
}